import { DocumentHistorique } from '@graphql/generated';
import { ConformiteHistorique } from '@lib/ged/models/document-conformite-historique.model';

export class DocumentHistoriqueMapper {
  public static fromGraphQl(input: DocumentHistorique): ConformiteHistorique {
    return {
      conforme: input.conforme,
      date: input.date,
      gestionnaire: {
        id: input.gestionnaire?.id ?? '',
        nom: input.gestionnaire?.nom ?? '',
        prenom: input.gestionnaire?.prenom ?? '',
      },
    };
  }
}
